import React from 'react'
import './Footer.css'
import { assets } from '../../assets/frontend_assets/assets'
const Footer = () => {
  return (
    <div className='footer' id='footer'>
      <div className='footer-content'>
        <div className='footer-content-left'>
          <img alt='' src={assets.logo}/>
          <p>Lorem ipsum dolor sit amet consectetur, adipprehenderitdeleniti porro reim praesentium voluptate alias, quisquam minus molestiae ipsa vitae ea sunt, veniam in expedita distinctio cupiditate illum reprehenderit nihil harum optio? Sint iure molestiae doloribus itaque non!</p>
          <div className='footer-social-icons'>
            <img src={assets.facebook_icon} alt="" />
            <img src={assets.twitter_icon} alt="" />
            <img src={assets.linkedin_icon} alt="" />
          </div>

        </div>
        <div className='footer-content-center'>
          <h2>Company</h2>
          <ul>
            <li>Home</li>
            <li>About Us</li>
            <li>Delivery</li>
            <li>Privacy</li>
          </ul>
          
        </div>
        <div className='footer-content-right'>
          <h2>Get In Touch</h2>
          <ul>
            <li>+91 8459908676</li>
            <li>rupeshmutkule2@gmail.com</li>
          </ul>
        </div>

      </div>
      <hr/>
      <p className="footer-copyright">Copyright 2025 @ Tomato.com - All Right Reserved</p>
      
    </div>
  )
}

export default Footer
